import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { clickTracker } from '../../../lib/common';
import { onClickEvent } from '../../../lib/gaAnalytics';
import { useAuth } from '../../../contexts/auth';
import styles from './HeaderAll.module.scss';
import { handleImpressionsTrack } from '../../../api';

export default function BannerHeader({
  bannerData,
  setShowBannerModal,
  setShowBannerTypeModal,
  loading,
  setActiveIndex,
  projectId,
  contractVal,
  handleBannerRedirection,
}) {
  const queryParams = new URLSearchParams(window.location.search);
  const jddrrCertificateFlag = queryParams.get('jdrrCertificate');
  const navigate = useNavigate();
  const getBannerType = sessionStorage.getItem('bannerType');
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const webBannerActive = getBannerType === 'Web Banner' && bannerData?.status === 'Active';
  const mobileBannerActive = getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'LIVE';
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const isBannerInprogress =
    (getBannerType === 'Web Banner' && bannerData?.showWebBannerInProgressImage) ||
    (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'Pending');

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleBackButton = async () => {
    sessionStorage.removeItem('faq');
    await clickTracker(`${getBannerType}_faq`.toLowerCase().replace(/\s/g, ''), 'headerback');
    await onClickEvent(
      `${getBannerType}`.toLowerCase().replace(/\s/g, ''),
      `${getBannerType}_back`.toLowerCase().replace(/\s/g, ''),
      'back',
    );
    if (jddrrCertificateFlag === '1') {
      navigate('/csportal?type=paid');
    } else {
      navigate(-1);
    }
  };

  const activeBannerImageUrl = mobileBannerActive
    ? bannerData?.mobileBannerImg || ''
    : getBannerType === 'Web Banner' && bannerData?.bannerImg !== ''
      ? bannerData?.bannerImg
      : '';

  const handleBannerImageClick = async () => {
    if (
      (getBannerType === 'Web Banner' && bannerData?.status !== 'Active') ||
      (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus !== 'LIVE')
    ) {
      if (projectId === 'csportal') {
        const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
        const liVal = 'click';
        const liTrd = `cta_buynow`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `issue_${bannerType}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
      handleBannerRedirection();
    }
  };
  const headerObj =
    getBannerType === 'Mobile Banner'
      ? bannerData?.mobileBannerHeaders
      : getBannerType === 'Web Banner'
        ? bannerData?.webBannerHeaders
        : {};
  const companyName =
    projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '';
  const hasDocId = projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '';
  return (
    <div className={`${styles.header_bannerbox}`}>
      <header className={`${styles.header_box} ${styles.header_banner}`}>
        <div
          aria-label="banner_header_back"
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          className={`${styles.header_left}`}
          onClick={handleBackButton}
        >
          <div className={`csicon ${styles.page_back_icon}`} />
        </div>
        <div className={`${styles.header_center}`}>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => {
              if (jddrrCertificateFlag !== '1') {
                setShowBannerTypeModal(true);
                document.body.style.overflow = 'unset';
                setActiveIndex(-1);
              }
            }}
            className={`${styles.header_text}`}
          >
            <div
              className="font12 fw600 color111 text-center"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              {getBannerType || ''}
              <div>
                {jddrrCertificateFlag !== '1' && (
                  <img
                    alt="angle_down_black"
                    src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/angle_down_black.svg"
                  />
                )}
              </div>
            </div>
            <div className={`${styles.tooltip_header} toolDate`}>
              <div className={`${styles.BusinessName__Header} font11 fw400 color111`}>{companyName || ''}</div>
            </div>
          </div>
        </div>
      </header>
      {getBannerType !== 'JDRR Certificate' && hasDocId && contractVal !== 'free' && (
        <div className={`${styles.bannerbox} mt-25`}>
          <div
            className={`${styles.banner_imgbox} ${
              projectId === 'genio' && !activeBannerImageUrl && !isBannerInprogress ? 'dn' : ''
            }`}
          >
            {loading ? (
              <div>Loading...</div>
            ) : (
              <>
                {activeBannerImageUrl ? (
                  <img
                    alt="banner_img"
                    src={activeBannerImageUrl}
                    style={{
                      cursor:
                        (getBannerType === 'Web Banner' && !['Active', 'InActive'].includes(bannerData?.status)) ||
                        (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus !== 'LIVE')
                          ? 'pointer'
                          : '',
                      height: '100%',
                      minWidth: '100%',
                      maxWidth:
                        ((getBannerType === 'Web Banner' && ['Active', 'InActive'].includes(bannerData?.status)) ||
                          mobileBannerActive) &&
                        'none',
                    }}
                  />
                ) : (
                  <div
                    tabIndex={0}
                    role="button"
                    onKeyDown={() => {}}
                    onClick={handleBannerImageClick}
                    className={`${isMobileView ? styles.MobileBanner : styles.DesktopBanner}`}
                  >
                    {(getBannerType === 'Web Banner' && bannerData?.showWebBannerInProgressImage) ||
                    (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'Pending') ? (
                      <div
                        className={`${
                          isMobileView ? styles.MobileBanner__Text : styles.DesktopBanner__Text
                        } text_center`}
                      >
                        <div className={`${isMobileView ? 'font13 fw700' : 'font24 fw600'} colorFFF`}>
                          {headerObj?.heading1}
                        </div>
                        <div className={`${isMobileView ? 'font11' : 'font18'} fw400 colorFFF mt-4`}>
                          {headerObj?.heading2}
                        </div>
                      </div>
                    ) : (
                      <>
                        {projectId === 'csportal' && (
                          <>
                            <div className={`${isMobileView ? 'font24 fw600 colorFFF' : styles.DesktopBanner__Text}`}>
                              <div className={`${isMobileView ? 'font11 fw700' : 'font24 fw600'} colorFFF`}>
                                {headerObj?.heading1}
                              </div>
                              <div className={`${isMobileView ? 'font11' : 'font18'} fw400 colorFFF`}>
                                {headerObj?.heading2}
                              </div>
                            </div>
                            <button
                              type="button"
                              className={`${
                                isMobileView
                                  ? `${styles.MobileBanner__Button} font12`
                                  : `${styles.DesktopBanner__Button} font20`
                              } fw700 color007 text_uppercase`}
                            >
                              BUY NOW
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          <div
            className={`${styles.banner_text} ${
              projectId === 'genio' && !activeBannerImageUrl && !isBannerInprogress ? '' : 'pt-20'
            }  pb-20 pl-15 pr-15`}
          >
            <div className={`${styles.banner_status}`}>
              <div className="font12 fw400 color111 mr-10">Status:</div>
              {(webBannerActive || mobileBannerActive) && (
                <div className={`${styles.status_dot} mr-5`}>
                  <div className={`${styles.status_dotinner}`} />
                </div>
              )}
              {(getBannerType === 'Web Banner' && bannerData && bannerData?.status) || mobileBannerActive ? (
                <div
                  className={`capitalize font12 fw500 font12 color3EB ${
                    bannerData?.status === 'InActive'
                      ? 'colorEC4'
                      : bannerData?.status === 'Active'
                        ? 'color339'
                        : 'color1A1'
                  }`}
                >
                  {getBannerType === 'Mobile Banner' ? bannerData?.mobileBannerStatus || '' : bannerData?.status || ''}
                </div>
              ) : (
                <div className="font12 fw400 font12" style={{ color: '#3ebd46' }}>
                  {(getBannerType === 'Web Banner' && bannerData?.showWebBannerInProgressImage) ||
                  (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'Pending')
                    ? 'Inprogress'
                    : 'No banner campaign found'}
                </div>
              )}
            </div>
            {(webBannerActive || mobileBannerActive) && (
              <div
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                style={{ cursor: 'pointer' }}
                onClick={async () => {
                  if (projectId === 'genio' && getBannerType === 'Mobile Banner') {
                    navigate(
                      `/${projectId}/create_ticket?parentId=${selectedBusinessGenio?.parentId}&city=${selectedBusinessGenio?.city}
        &key=${getBannerType}&vertical=''`,
                    );
                  } else {
                    setShowBannerModal(true);
                    if (projectId === 'csportal') {
                      const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
                      const liVal = 'click';
                      const liTrd = `cta_customization`;
                      const faqTypeVal = '';
                      const othersData = [];
                      const llTrd = `issue_${bannerType}`;
                      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                    }
                  }
                }}
                className="font12 fw500 color007 pointer"
              >
                Suggest Customization
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

BannerHeader.propTypes = {
  bannerData: PropTypes.object,
  setShowBannerModal: PropTypes.func,
  setShowBannerTypeModal: PropTypes.func,
  loading: PropTypes.bool,
  setActiveIndex: PropTypes.func,
  projectId: PropTypes.string,
  contractVal: PropTypes.string,
  handleBannerRedirection: PropTypes.func,
};
